import React, { Component } from 'react';
import styles from './Upload.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import {connect} from 'react-redux';
import firebase from '../../../firebase';
import axios from 'axios';
import AvatarEditor from 'react-avatar-editor'
import Slider from '@material-ui/core/Slider';

class Upload extends Component {

    state ={
        file: null,
        fileSelected: false,
        filename: 'No File Selected',
        error: false,
        uploading: false,
        scale: 1,
        rotate: 0,
        width: this.props.width,
        height: this.props.height
        
    }
    editorRef = React.createRef();
    captionRef = React.createRef();

    fileOnchange = (event) => {
        const file = event.target.files[0];
        this.setState({filename: 'No File Selected', fileSelected: false, error: false})
        if(file) {
            this.setState({filename: '', fileSelected: true, file: file});
            if(file.type.indexOf('image') !== 0) {
                this.setState({error: true, fileSelected: false});
            }
        } 
        
    }

    onUpload = (event) => {
       event.target.disabled = true;
       this.setState({uploading:true});
       const blob = this.dataURLtoBlob(this.editorRef.current.getImageScaledToCanvas().toDataURL());
       const fileName = this.props.type === 'ADD_POST' ? 
                        this.state.file.name + Math.floor(Math.random()*12*55555) : 'profile_pic';
       const uploadTask =  firebase.storage().ref('images/' + this.props.loginStatus.userId + '/' + fileName).put(blob);
       uploadTask.on('state_changed',
        (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
        },
        (err)=>console.log(err),
        ()=>{
            uploadTask.snapshot.ref.getDownloadURL().then(url => {
               if(this.props.type === 'ADD_POST') this.uploadPost(url);
               else this.uploadProfilePic(url);
            })
        }
        )
    
    }

    uploadProfilePic = (url) => {
        axios.put('/users/'+ this.props.loginStatus.userId 
        + '/profilePic.json?auth=' + this.props.loginStatus.authToken, JSON.stringify(url))
        .then(()=>this.props.close());
    }

    uploadPost = (url) => {
        const desc = this.captionRef.current.value.trim();
        const post = {
            url: url,
            desc: desc !== ''? desc : 'NA',
            likes:[''],
            comments: [{comment: 'NA'}],
            timestamp: new Date()
        }
        axios.get('/users/'+ this.props.loginStatus.userId 
        + '/posts.json?auth=' + this.props.loginStatus.authToken)
        .then(response => {
            response.data.push(post);
            axios.put('/users/'+ this.props.loginStatus.userId 
            + '/posts.json?auth=' + this.props.loginStatus.authToken, response.data)
            .then(()=>this.props.close());
        });
    }

    dataURLtoBlob = (dataurl) => {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type:mime});
    }

    onScaleChange = (event, value) => {
       this.setState({scale:value})
    }
    rotate = () => {
        this.setState({rotate: this.state.rotate + 90,width: this.state.height,height: this.state.width});
    }
    
    render() {
        return(
            <div className={styles.main}>
                <div className={styles.modal}>
                    <div>
                        <button className={styles.close} onClick={this.props.close}>
                        <svg fill="#262626" height="24" viewBox="0 0 48 48" width="24">
                                <path  d="M41.1 9.1l-15 15L41 39c.6.6.6 1.5 0 2.1s-1.5.6-2.1 
                                0L24 26.1l-14.9 15c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l14.9-15-15-15c-.6-.6-.6-1.5 
                                0-2.1s1.5-.6 2.1 0l15 15 15-15c.6-.6 1.5-.6 2.1 0 .6.6.6 1.6 0 2.2z">
                                </path></svg>
                        </button>
                    </div>
                    <div className={styles.body}>
                        <label>
                            <input type="file" accept="image/*" onChange={(event)=>this.fileOnchange(event)} style={{display:'none'}}/>
                            <div className={styles.select}>
                                <FontAwesomeIcon icon={faCamera} size="lg" color="grey" style={{marginRight:'10px'}} />
                                 {this.props.type === 'ADD_POST' ? 'Choose Image' :'Change Profile Picture'}
                            </div>
                        </label>
                        <div className={styles.filename}> {this.state.filename} </div>
                        {this.state.error?
                        <div className={styles.error}> Invalid File Format </div> : null
                        }
                        {this.state.fileSelected ?
                        <div>
                            {this.props.type === 'ADD_POST' ?
                            <div>
                                <textarea className={styles.formTextArea} placeholder="Write a caption..."
                                ref={this.captionRef}></textarea>
                            </div>:null
                            }
                            <div>
                            <AvatarEditor ref={this.editorRef} image={this.state.file} 
                            borderRadius={this.props.radius} rotate={this.state.rotate}
                            border={this.props.border} width={this.state.width} height={this.state.height} scale={this.state.scale}/>
                            </div>
                            <div style={{display:'flex'}}>
                            <button className={styles.rotate} onClick={this.rotate}></button>
                            <Slider onChange={this.onScaleChange} step={0.01} min={1} max={5} style={{width:'60%',marginLeft:'30px'}} />
                           </div>
                        </div> : null
                        }
                         
                        <div style={{marginTop:'20px',marginBottom:'10px'}}>
                            {this.state.fileSelected ?
                                <button className={styles.upload} onClick={(event)=>this.onUpload(event)}>
                                  {this.state.uploading ? 'Uploading...' : 'Upload'}  
                                </button> : null
                            }
                        </div>
                       
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}
export default connect(mapStateToProps)(Upload);